module.exports = __webpack_public_path__ + "img/ic_design_item7.6db36ea6.png";